<div [formGroup]="fg()">
  <div class="action-setting">
    <div class="action-setting-title">
      {{ 'commonActions.actionStatus.description' | labelsProvider }}
    </div>

    <mat-radio-group [value]="actionStatus()" (change)="onRadioButtonChange($event.value)">
      <div class="radio-option">
        <mat-radio-button [value]="actionStatusEnum.enabled">
          {{ 'commonActions.actionStatus.enableLabel' | labelsProvider }}
        </mat-radio-button>
        <div class="radio-description">
          {{ 'commonActions.actionStatus.enableDescription' | labelsProvider }}
        </div>
      </div>

      <div class="radio-option">
        <mat-radio-button [value]="actionStatusEnum.disabled">
          {{ 'commonActions.actionStatus.disableLabel' | labelsProvider }}
        </mat-radio-button>
        <div class="radio-description">
          {{ 'commonActions.actionStatus.disableDescription' | labelsProvider }}
        </div>
      </div>
    </mat-radio-group>
  </div>
</div>
